/** Editable reason chips per command intent (XAP-09, owner Q8). */

const DEFAULT = ['بررسی عملیاتی', 'درخواست مدیریت', 'اصلاح داده'] as const;

const BY_PREFIX: Readonly<Record<string, readonly string[]>> = {
  'buyer.': ['بررسی ریسک', 'درخواست خریدار', 'تطبیق مدارک'],
  'merchant.status.': ['تخلف فروشگاه', 'ریسک عملیاتی', 'درخواست فروشگاه'],
  'merchant.': ['به‌روزرسانی قرارداد', 'اصلاح ثبت', 'درخواست فروشگاه'],
  'physical-card.status.BLOCKED': ['مفقودی', 'کارت مخدوش', 'درخواست خریدار'],
  // D-117: K7 (before the generic `physical-card` row). The numbering chips are per row action.
  'physical-card.number-change': ['تغییر شهر خریدار', 'انتقال به سری جدید', 'درخواست پشتیبانی'],
  // D-118: printing a card again and downloading a print file again (before `physical-card`).
  'physical-card-print': ['خرابی چاپ', 'کارت گم شد در چاپخانه'],
  'physical-card': ['کارت گم شده', 'کارت مخدوش', 'صدور مجدد'],
  'platform.': ['نیاز تیم', 'جابه‌جایی نقش', 'حسابرسی'],
  'approval.': ['مغایرت با سیاست', 'اطلاعات ناقص', 'درخواست مجدد'],
  'credit.': ['برنامه فصلی', 'هدف‌گذاری', 'اصلاح سقف'],
  'policy.': ['نسخه جدید', 'تطبیق مقررات', 'اصلاح سقف'],
  'delinquency.late-fee-waiver': ['بخشودگی موردی', 'خطای ارزیابی', 'توافق وصول'],
  'delinquency.write-off': ['مطالبه غیرقابل وصول', 'گذشت مهلت سیاست', 'تصمیم مالی'],
};

export function reasonPresetsForIntent(intent: string): readonly string[] {
  for (const [prefix, presets] of Object.entries(BY_PREFIX)) {
    if (intent.includes(prefix)) {
      return presets;
    }
  }
  return DEFAULT;
}
